import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const langs = [
  { code: 'en', key: 'lang.en' },
  { code: 'pl', key: 'lang.pl' },
  { code: 'es', key: 'lang.es' },
  { code: 'fr', key: 'lang.fr' },
];

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);

  const current = langs.find((l) => l.code === i18n.language) || langs[0];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-foreground-900"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-global-line text-base"></i>
        </span>
        <span>{t(current.key)}</span>
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={`text-base ${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
        </span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 z-20 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1">
            {langs.map((l) => (
              <button
                key={l.code}
                type="button"
                onClick={() => {
                  i18n.changeLanguage(l.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-2 text-left text-sm transition-colors hover:bg-background-100 ${
                  l.code === current.code ? 'font-semibold text-primary-600' : 'text-foreground-700'
                }`}
              >
                <span>{t(l.key)}</span>
                {l.code === current.code && (
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-check-line text-base"></i>
                  </span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}